import ProjectOrganisationBuilding from "./project-organisation-building.ts";
import ContainsFiles from "./contains-files.ts";
import ProjectOrganisationStorey from "./project-organisation-storey.ts";
import IDirtyFlag from "@/models/interfaces/dirty-flag.ts";
import { StoreyTypologyType } from "@/models/types/storey-typology-type.ts";
import BaseFileData from "./base-file-data.ts";
import FileData2D from "./file-data-2d.ts";

class ProjectOrganisation extends ContainsFiles implements IDirtyFlag {
    isDirty = false;

    buildings: ProjectOrganisationBuilding[] = [];

    public setDirtyFlag(newFlag: boolean): void {
        this.isDirty = newFlag;
    }

    public getBuilding(buildingId: string): ProjectOrganisationBuilding | undefined {
        return this.buildings.find(b => b.id === buildingId);
    }

    public getStoreyBuilding(buildingId: string, storeyId: string): ProjectOrganisationStorey | undefined {
        const targetBuilding = this.buildings.find(b => b.id === buildingId);
        return targetBuilding?.getStorey(storeyId);
    }

    public findBuildingStoreyAndFileFromFileId(fileId: string): { building: ProjectOrganisationBuilding; storey: ProjectOrganisationStorey; file: BaseFileData }
        | undefined {
        return this.buildings.reduce<
            { building: ProjectOrganisationBuilding; storey: ProjectOrganisationStorey; file: BaseFileData }
            | undefined
        >((found, building) => {
            if (found) return found;

            const match = building.findStoreyAndFileFromFileId(fileId);
            return match ? { building, storey: match.storey, file: match.file } : undefined;
        }, undefined);
    }

    public addBuilding(name: string) {
        const id = crypto.randomUUID();
        const newBuilding = new ProjectOrganisationBuilding(id, name);
        newBuilding.setFile3dFrom2d(crypto.randomUUID(), 0, '', '');

        this.buildings.push(newBuilding);
        return newBuilding;
    }

    public addStorey(buildingId: string, name: string, altimetry: number, storeyType: StoreyTypologyType) {
        const building = this.getBuilding(buildingId);
        if (building)
            return building.addStorey(name, altimetry, storeyType);
        return null;
    }

    public addStoreyFile(buildingId: string, storeyId: string, file: FileData2D) {
        const building = this.getBuilding(buildingId);
        if (building) {
            const storey = building.getStorey(storeyId);
            if (storey) {
                storey.addFile(file.fileType, file.id, file.name, file.revision, file.relativePath, file.fileMetaObject, file.content);
            }
        }
    }

    public removeBuilding(buildingId: string) {
        const idx = this.buildings.findIndex(b => b.id === buildingId);
        if (idx !== -1) this.buildings.splice(idx, 1);
    }
}

export default ProjectOrganisation;